<template>
  <div class="tabs mr-12" :class="{
      tabs_light: !isDark,
    }">
    <div
      class="tabs-item"
      @click="changeView('works')"
      :class="{
        'tabs-item_active': 'works' === active,
      }"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.7482 5.8163C13.7482 5.8163 13.2478 2.7509 10.933 2.53199C10.9017 2.50072 10.9955 2 10.2133 2C9.43153 2 9.52535 2.50072 9.49408 2.53199C7.17957 2.7509 6.67885 5.8163 6.67885 5.8163L6.27231 6.28575C6.55376 7.44282 10.2133 7.44282 10.2133 7.44282C10.2133 7.44282 13.8733 7.44282 14.1547 6.28575L13.7482 5.8163Z"
          :stroke="getColor('works')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1978 7.9903C8.99313 7.9903 7.85061 7.82667 6.82589 7.53467C6.77499 7.75212 6.74808 7.97757 6.74808 8.2092C6.74808 9.10592 7.15025 9.91645 7.79715 10.4961C8.06151 11.6877 9.04295 12.5728 10.2135 12.5728C11.384 12.5728 12.3654 11.6877 12.6298 10.4961C13.2771 9.91645 13.6792 9.10592 13.6792 8.2092C13.6792 7.97466 13.6516 7.7463 13.5992 7.52631C12.5669 7.82376 11.4142 7.9903 10.1978 7.9903Z"
          :stroke="getColor('works')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.5468 12.9637C14.4519 12.3383 12.5752 11.6187 12.5752 11.6187C12.5752 11.6187 11.668 12.995 10.1978 12.995C8.72765 12.995 7.82039 11.6187 7.82039 11.6187C7.82039 11.6187 5.94369 12.3383 4.84917 12.9637C3.75427 13.5895 2.94083 15.6226 3.00338 16.78C3.81682 17.9375 10.1978 18 10.1978 18C10.1978 18 16.5788 17.9375 17.3922 16.78C17.4548 15.6226 16.6417 13.5895 15.5468 12.9637Z"
          :stroke="getColor('works')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.72488 13.0264L6.85105 12.5883V14.9969H5.72488V13.0264Z"
          :stroke="getColor('works')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7334 13.0264L13.6073 12.5883V14.9969H14.7334V13.0264Z"
          :stroke="getColor('works')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1978 17.4681C10.1978 17.4681 13.2691 17.4379 15.4218 17.0332V16.071C15.4218 15.7372 15.1509 15.4663 14.8167 15.4663H5.64155C5.30774 15.4663 5.03683 15.7372 5.03683 16.071V17.0448C7.18589 17.4386 10.1978 17.4681 10.1978 17.4681Z"
          :stroke="getColor('works')"
          stroke-linejoin="round"
        />
      </svg>

      <div class="tabs-item__text">
        <span>{{$t('controls.works')}}</span>
      </div>
    </div>

    <div
      class="tabs-item"
      @click="changeView('skills')"
      :class="{
        'tabs-item_active': 'skills' === active,
      }"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        :fill="getColor('skills')"
        viewBox="0 0 64 64"
        width="20"
        height="20"
      >
        <g id="Outline">
          <path
            d="M29,14.979V18a3,3,0,0,0,6,0V14.979a5,5,0,1,0-6,0ZM33,18a1,1,0,0,1-2,0V17h2ZM32,8a3,3,0,0,1,3,3,2.968,2.968,0,0,1-1.5,2.581,1,1,0,0,0-.5.864V15H31v-.555a1,1,0,0,0-.5-.864A2.968,2.968,0,0,1,29,11,3,3,0,0,1,32,8Z"
          />
          <circle cx="40" cy="11" r="1" />
          <circle cx="24" cy="11" r="1" />
          <circle cx="32" cy="3" r="1" />
          <path d="M36.95,15.95a1,1,0,1,0,1.414,0A1,1,0,0,0,36.95,15.95Z" />
          <path d="M27.05,6.05a1,1,0,1,0-1.414,0A1,1,0,0,0,27.05,6.05Z" />
          <path d="M27.05,17.364a1,1,0,1,0-1.414,0A1,1,0,0,0,27.05,17.364Z" />
          <path d="M38.364,6.05a1,1,0,1,0-1.414,0A1,1,0,0,0,38.364,6.05Z" />
          <path
            d="M61.5,21.9l-.586-.339c.016-.189.024-.376.024-.563s-.008-.374-.024-.563L61.5,20.1a1,1,0,0,0-1-1.732l-1.167.674a1,1,0,0,0-.483,1.047,4.78,4.78,0,0,1,0,1.826,1,1,0,0,0,.483,1.047l.3.174-1,1.732-.3-.174a1,1,0,0,0-1.149.106,4.972,4.972,0,0,1-1.58.91,1,1,0,0,0-.666.943V27h-2v-.349a1,1,0,0,0-.667-.943,4.978,4.978,0,0,1-1.579-.91,1,1,0,0,0-1.15-.106l-.3.174-1-1.732.3-.174a1,1,0,0,0,.483-1.047,4.834,4.834,0,0,1,0-1.826,1,1,0,0,0-.483-1.047l-.3-.174,1-1.732.3.174a1,1,0,0,0,1.15-.106,4.978,4.978,0,0,1,1.579-.91,1,1,0,0,0,.667-.943V15h2v.349a1,1,0,0,0,.666.943,4.972,4.972,0,0,1,1.58.91,1,1,0,0,0,1.149.106l1.167-.674a1,1,0,1,0-1-1.732l-.589.34a6.8,6.8,0,0,0-.973-.561V14a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v.681a6.87,6.87,0,0,0-.974.561l-.589-.34a1,1,0,0,0-1.366.366l-2,3.464a1,1,0,0,0,.366,1.366l.587.339c-.016.19-.024.378-.024.563s.008.373.024.563l-.587.339a1,1,0,0,0-.366,1.366l2,3.464a1,1,0,0,0,1.366.366l.589-.34a6.87,6.87,0,0,0,.974.561V28a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-.681a6.8,6.8,0,0,0,.973-.561l.589.34a1,1,0,0,0,1.366-.366l2-3.464A1,1,0,0,0,61.5,21.9Z"
          />
          <path
            d="M50.938,21a3,3,0,1,0,3-3A3,3,0,0,0,50.938,21Zm4,0a1,1,0,1,1-1-1A1,1,0,0,1,54.938,21Z"
          />
          <path
            d="M10,28a1,1,0,0,1-1-1,1,1,0,0,0-2,0,3,3,0,0,0,2,2.816V31a1,1,0,0,0,2,0V29.816A2.993,2.993,0,0,0,10,24a1,1,0,1,1,1-1,1,1,0,0,0,2,0,3,3,0,0,0-2-2.816V19a1,1,0,0,0-2,0v1.184A2.993,2.993,0,0,0,10,26a1,1,0,0,1,0,2Z"
          />
          <path
            d="M57.2,41.367l-2.974-.432L52.9,38.24a1.041,1.041,0,0,0-1.792,0l-1.331,2.7-2.974.432a1,1,0,0,0-.554,1.706l2.152,2.1-.508,2.962a1,1,0,0,0,1.451,1.054l2.66-1.4,2.66,1.4a1,1,0,0,0,1.451-1.054L55.6,45.171l2.152-2.1a1,1,0,0,0-.554-1.706Zm-3.37,2.739a1,1,0,0,0-.288.885l.254,1.483-1.332-.7a1.005,1.005,0,0,0-.93,0l-1.332.7.254-1.483a1,1,0,0,0-.288-.885l-1.077-1.051,1.489-.216a1,1,0,0,0,.752-.547L52,40.942l.667,1.35a1,1,0,0,0,.752.547l1.489.216Z"
          />
          <path
            d="M17.924,44.383a1,1,0,0,0-.217-1.09l-5-5a1,1,0,0,0-1.414,0l-5,5A1,1,0,0,0,7,45H9v4a1,1,0,0,0,2,0V44a1,1,0,0,0-1-1H9.414L12,40.414,14.586,43H14a1,1,0,0,0-1,1v5a1,1,0,0,0,2,0V45h2A1,1,0,0,0,17.924,44.383Z"
          />
          <path
            d="M17.412,52.24a1,1,0,0,0-1.3,1.52,25.99,25.99,0,0,0,2.328,1.782,1,1,0,0,0,1.122-1.656A23.891,23.891,0,0,1,17.412,52.24Z"
          />
          <path
            d="M49.532,51.388a24.071,24.071,0,0,1-5.012,3.67,1,1,0,1,0,.96,1.754,26.069,26.069,0,0,0,5.431-3.975,1,1,0,0,0-1.379-1.449Z"
          />
          <path
            d="M18.888,12.168a26.09,26.09,0,0,0-6.051,5.421,1,1,0,0,0,1.551,1.264,24.051,24.051,0,0,1,5.587-5.006,1,1,0,1,0-1.087-1.679Z"
          />
          <path
            d="M44.411,12.882c.377.2.747.418,1.111.642a1,1,0,1,0,1.045-1.7c-.4-.242-.8-.476-1.2-.7a1,1,0,1,0-.951,1.76Z"
          />
          <path
            d="M8.2,38.14a.884.884,0,0,0,.125-.008A1,1,0,0,0,9.2,37.016,24.151,24.151,0,0,1,9,34a1,1,0,0,0-2,0,26.011,26.011,0,0,0,.211,3.264A1,1,0,0,0,8.2,38.14Z"
          />
          <path
            d="M57.834,31a1,1,0,0,0-.918,1.076C56.973,32.792,57,33.42,57,34a24.265,24.265,0,0,1-.377,4.22,1,1,0,0,0,.809,1.159.96.96,0,0,0,.176.016,1,1,0,0,0,.983-.825A26.14,26.14,0,0,0,59,34c0-.633-.029-1.313-.09-2.079A1.006,1.006,0,0,0,57.834,31Z"
          />
          <path
            d="M36.439,45.022A5.965,5.965,0,0,0,38,41V40a1,1,0,0,0-2,0v1a4,4,0,0,1-8,0V37h9a1,1,0,0,0,1-1,5.006,5.006,0,0,0-5-5H25a1,1,0,0,0-1,1v2a3,3,0,0,0,2,2.816V41a5.965,5.965,0,0,0,1.561,4.022A6,6,0,0,0,22,51V61a1,1,0,0,0,2,0V51a4,4,0,0,1,4-4h1v1a2.989,2.989,0,0,0,.871,2.11l-.865,7.78a1,1,0,0,0,.287.817l2,2a1,1,0,0,0,1.414,0l1.62-1.62a2.1,2.1,0,0,0,.607-1.731l-.8-7.247A2.985,2.985,0,0,0,35,48V47h1a4,4,0,0,1,4,4V61a1,1,0,0,0,2,0V51A6,6,0,0,0,36.439,45.022ZM26,33h7a3.006,3.006,0,0,1,2.829,2H27a1,1,0,0,1-1-1Zm6.913,24.673L32,58.586l-.952-.953.75-6.653c.068,0,.133.02.2.02s.142-.016.214-.022l.733,6.6A.118.118,0,0,1,32.913,57.673ZM33,48a1,1,0,0,1-2,0V47h2Z"
          />
        </g>
      </svg>

      <div class="tabs-item__text">
        <span>{{$t('controls.skills')}}</span>
      </div>
    </div>

    <div
      class="tabs-item"
      @click="changeView('tools')"
      :class="{
        'tabs-item_active': 'tools' === active,
      }"
    >
      <svg
        id="Layer_3"
        width="20"
        height="20"
        viewBox="0 0 64 64"
        :fill="getColor('tools')"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="m62 33h-1v-23c0-2.757-2.243-5-5-5h-18v-3c0-.552-.448-1-1-1h-10c-.552 0-1 .448-1 1v3h-18c-2.757 0-5 2.243-5 5v23h-1c-.552 0-1 .448-1 1v23c0 3.309 2.691 6 6 6h50c3.309 0 6-2.691 6-6v-23c0-.552-.448-1-1-1zm-34-30h8v2h-8zm-23 7c0-1.654 1.346-3 3-3h48c1.654 0 3 1.346 3 3v23h-2v-23c0-.552-.448-1-1-1h-48c-.552 0-1 .448-1 1v23h-2zm25.895 11.553-.895-1.789v-2.764h4v2.764l-.895 1.789c-.069.138-.105.292-.105.447v6h-2v-6c0-.155-.036-.309-.105-.447zm4.105 8.447v3h-6v-3zm-7 5h8v4h-8zm9-2v-4c0-.552-.448-1-1-1h-1v-5.764l.895-1.789c.069-.138.105-.292.105-.447v-4c0-.552-.448-1-1-1h-6c-.552 0-1 .448-1 1v4c0 .155.036.309.105.447l.895 1.789v5.764h-1c-.552 0-1 .448-1 1v4h-6v-5.333c2.419-1.149 4-3.605 4-6.319 0-2.956-1.875-5.606-4.666-6.594-.307-.107-.646-.062-.911.126s-.423.493-.423.817v5.237l-1 1-1-1v-5.237c0-.325-.158-.629-.423-.816-.265-.188-.604-.233-.911-.126-2.791.988-4.666 3.638-4.666 6.594 0 2.714 1.581 5.17 4 6.319v5.332h-6v-22h46v22h-6v-5.333c2.419-1.149 4-3.605 4-6.319 0-2.956-1.875-5.606-4.666-6.594-.306-.107-.646-.062-.911.126s-.423.493-.423.817v5.237l-1 1-1-1v-5.237c0-.325-.158-.629-.423-.816-.265-.188-.605-.233-.911-.126-2.791.988-4.666 3.638-4.666 6.594 0 2.714 1.581 5.17 4 6.319v5.332zm-26 10h6v2h-6zm6-2h-6v-6h6zm-.666-14.943c-1.994-.706-3.334-2.598-3.334-4.708 0-1.595.765-3.065 2-3.993v3.993c0 .265.105.52.293.707l2 2c.391.391 1.023.391 1.414 0l2-2c.188-.188.293-.442.293-.707v-3.993c1.235.928 2 2.398 2 3.993 0 2.11-1.34 4.002-3.334 4.708-.399.142-.666.519-.666.943v6h-2v-6c0-.424-.267-.801-.666-.943zm28 0c-1.994-.706-3.334-2.598-3.334-4.708 0-1.595.765-3.065 2-3.993v3.993c0 .265.105.52.293.707l2 2c.391.391 1.023.391 1.414 0l2-2c.188-.188.293-.442.293-.707v-3.993c1.235.928 2 2.398 2 3.993 0 2.11-1.34 4.002-3.334 4.708-.399.142-.666.519-.666.943v6h-2v-6c0-.424-.267-.801-.666-.943zm2.666 16.943h6v2h-6zm6-2h-6v-6h6zm8 16c0 2.206-1.794 4-4 4h-50c-2.206 0-4-1.794-4-4v-22h6v11c0 .552.448 1 1 1h8c.552 0 1-.448 1-1v-11h7v5c0 .552.448 1 1 1h10c.552 0 1-.448 1-1v-5h7v11c0 .552.448 1 1 1h8c.552 0 1-.448 1-1v-11h6z"
          />
        </g>
      </svg>

      <div class="tabs-item__text">
        <span>{{$t('controls.tools')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        active: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            activeTheme: 'activeTheme',
        }),
        isDark() {
            return this.activeTheme === 'dark'
        },
    },
    methods: {
        changeView(view) {
            this.$emit('changeView', view)
        },
        getColor(tab) {
            if (tab === this.active) {
                return this.isDark ? '#000' : '#304156'
            }

            return this.isDark ? '#fff' : '#304156'
        },
    },
}
</script>
